import React from 'react';
import { faCheck, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function GovernanceProcessingStatusIcon({ processing }: { processing: boolean }) {
  if (processing) {
    return (
      <div className="h-6 w-6 rounded-full bg-primary/10 flex items-center justify-center">
        <FontAwesomeIcon icon={faSpinner} spin className="text-dark text-sm" />
      </div>
    );
  }

  return (
    <div className="h-6 w-6 rounded-full bg-emerald-500 flex items-center justify-center">
      <FontAwesomeIcon icon={faCheck} className="text-white text-xs" />
    </div>
  );
}
